module.exports = __webpack_public_path__ + "static/img/djcj.f215408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/djcj.png
// module id = itBC
// module chunks = 1